<template>
  <div class="zero">
    <LightningIcon class="zero__icon" />
    <span class="zero__txt">Список оповещений пуст</span>
  </div>
</template>

<script setup>
  import LightningIcon from '@/Groups/Notifications/private/svg/LightningIcon.vue';
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>